import api from "api";
import ApiCaller from "api/apiCaller";
import DataPipeline from "model/data_pipeline";
import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import {
  Col,
  Container,
} from "reactstrap";
import "./index.css";

export default function DataPipelineTaskLog() {
  const companyId = api.getCurrentCompanyId();
  const match = useRouteMatch("/data_pipeline_log/:data_pipeline_id/task/:data_pipeline_task_id");
  const params: any = match?.params;
  const dataPipelineId = params?.data_pipeline_id;
  const dataPipelineTaskId = params?.data_pipeline_task_id;
  const [dataPipelineTaskLog, setDataPipelineTaskLog] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const getDataPipelineTaskLog = async () => {
    setIsLoading(true);
    const res:any = await ApiCaller.get(`pipeline/${dataPipelineId}/task/${dataPipelineTaskId}/log?company_id=${companyId}`);
    if (res.data) {
      setDataPipelineTaskLog(res.data.log);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getDataPipelineTaskLog();
  }, []);
  return (
    <Container>
      <Col xs={12}>
        <h1></h1>
        <h3>Task ID: {dataPipelineTaskId} log</h3>
      </Col>
      <Col xs={12}>
        <div className="pipeline-task-log__code-block">
          <code>
            {isLoading && <p>Fetching log, please wait... 😘😘😘</p>}
            {dataPipelineTaskLog}
          </code>
        </div>
      </Col>
    </Container>
  );
}
